// @ts-nocheck
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { TypographyProps } from "@store/MobiusOverrides/Typography/Typography";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    isSignedIn: !!state.context.session.userName && !getCurrentUserIsGuest(state),
});

type OwnProps = HasProductContext & ReturnType<typeof mapStateToProps>;

export interface HubspotChatLinkStyles {
    specialOrderInfosBox?: InfosBoxProps;
    hubspotChatLink?: LinkPresentationProps;
    primaryText?: TypographyProps;
    secondaryText?: TypographyProps;
}

export const hubspotChatLinkStyles: HubspotChatLinkStyles = {
    specialOrderInfosBox: {
        type: "specialOrder",
        size: "medium",
        showIcon: true,
        extendedStyles: {
            wrapper: {
                css: css`
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                    margin: ${pxToRem(16)} 0;
                    width: auto;
                    ${breakpoint("sm")} {
                        ${x => cssProp("font-size", x.theme.design.typography.size.smaller)}
                    }
                `,
            },
        },
    },
    hubspotChatLink: {
        css: css`
            color: inherit;
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        `,
    },
    primaryText: {
        variant: "p",
    },
    secondaryText: {
        variant: "p",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
};

const styles = hubspotChatLinkStyles;

const SpecialOrderInfoBox: React.FC<OwnProps> = ({ isSignedIn }) => {
    if (!isSignedIn) {
        return null;
    }

    return (
        <InfosBox {...styles.specialOrderInfosBox}>
            <Typography {...styles.primaryText}>{translate("grimco_orderedAsNeeded_note_p1")}</Typography>
            <Typography {...styles.secondaryText}>{translate("grimco_orderedAsNeeded_note_p2")}</Typography>
            <Link
                onClick={event => {
                    event.preventDefault();
                    window.HubSpotConversations.widget.open();
                }}
                {...styles.hubspotChatLink}
            >
                {translate("Grimco_SplitShipping_ChatForLeadTime")}
            </Link>
        </InfosBox>
    );
};

export default connect(mapStateToProps)(withProductContext(SpecialOrderInfoBox));
